export const version = "signing-key/5.5.0";
//# sourceMappingURL=_version.js.map